import React from 'react';
import ExternalBlock from '../ExternalBlock';
import {} from './ExternalContent.types';
const ExternalContent = ({ currentStep = {}, ...rest }) => (React.createElement(React.Fragment, null, currentStep.blocks?.map((block, idx) => (React.createElement(ExternalBlock, { key: `block-${idx + 1}`, ...block, ...rest })))));
export default ExternalContent;
